import { render } from "./BuyTravelPass.vue?vue&type=template&id=b0fa80b4&scoped=true&lang=pug"
import script from "./BuyTravelPass.vue?vue&type=script&lang=ts"
export * from "./BuyTravelPass.vue?vue&type=script&lang=ts"

import "./BuyTravelPass.vue?vue&type=style&index=0&id=b0fa80b4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b0fa80b4"

export default script